import each from 'lodash/each'
import isObject from 'lodash/isObject'


const findDeep = (coll: unknown, matches: (val: unknown, key: string | number) => boolean): boolean => {
  let found = false
  each(coll as Record<string, unknown> | unknown[], (val: unknown, key: string | number) => {
    if (Array.isArray(val) || isObject(val)) {
      if (findDeep(val, matches)) {
        found = true
      }
    }
    if (matches(val, key)) {
      found = true
    }
  })
  return found
}

export default findDeep
